import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceLine } from '../../../models/invoice-line';
import { InvoiceLinesService } from '../../services/invoice-lines.service';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
	selector: 'app-invoice-line-inline-form',
	templateUrl: 'invoice-line-inline-form.template.html'
})

/**
 * Component used for inline creation of a new InvoiceLine
 */
export class InvoiceLineInlineFormComponent
{
	open: false;
	@Input() invoiceId;
	@Input() invoiceLine: InvoiceLine = new InvoiceLine();

	@Output() onInvoiceLineSave = new EventEmitter<InvoiceLine>();

	constructor(private messageService: MessageService)
	{
	}

	/**
	 * Throws onInvoiceLineSave event.
	 *
	 * @param {InvoiceLine} invoiceLine
	 *
	 * @return void
	 */
	invoiceLineChange(invoiceLine: InvoiceLine)
	{
		this.messageService.add({
			summary: 'Succes',
			detail: 'De factuurregel is aangemaakt.',
			severity: 'success'
		});

		this.onInvoiceLineSave.emit(invoiceLine);
		this.open = false;
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-detail/invoice-line/invoice-line-inline-form.component.ts